<template>
  <head>
    <meta charset="utf-8" />
    <title>HOSPITAL MANAGEMENT INFORMATION SYSTEM</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="HMIS By Craft Silicon Payments" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Designations</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="#">Organization Structure</a></li>
                    <li class="breadcrumb-item"><a href="#">Designations</a></li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Ethiopian/Gregorian Date Filter Section -->
          <div class="row mb-3">
            <div class="col-12">
              <div class="card mb-0">
                <div class="card-body py-2">
                  <div class="row g-2 align-items-center">
                    <!-- Calendar Type Toggle -->
                    <div class="col-auto">
                      <div class="btn-group btn-group-sm" role="group">
                        <input type="radio" class="btn-check" name="calendarType" id="calEth" :value="true" v-model="showEthiopianDates">
                        <label class="btn btn-outline-primary" for="calEth">
                          <i class="bx bx-calendar me-1"></i>Ethiopian
                        </label>
                        <input type="radio" class="btn-check" name="calendarType" id="calGreg" :value="false" v-model="showEthiopianDates">
                        <label class="btn btn-outline-success" for="calGreg">
                          <i class="bx bx-calendar-alt me-1"></i>Gregorian
                        </label>
                      </div>
                    </div>

                    <!-- Date Selection -->
                    <div class="col">
                      <div class="row g-2 align-items-center">
                        <div class="col-auto">
                          <span class="badge bg-secondary">From</span>
                        </div>
                        <div class="col-auto">
                          <select v-model="dateFilterRange.fromDay" @change="updateDateRange" class="form-select form-select-sm" style="width: 65px;">
                            <option value="">{{ showEthiopianDates ? 'ቀን' : 'Day' }}</option>
                            <option v-for="d in fromDaysInMonth" :key="d" :value="d">{{ d }}</option>
                          </select>
                        </div>
                        <div class="col-auto">
                          <select v-model="dateFilterRange.fromMonth" @change="onFromMonthChange" class="form-select form-select-sm" style="width: 115px;">
                            <option value="">{{ showEthiopianDates ? 'ወር' : 'Month' }}</option>
                            <option v-for="m in displayMonths" :key="m.value" :value="m.value">
                              {{ showEthiopianDates ? m.label : m.labelShort }}
                            </option>
                          </select>
                        </div>
                        <div class="col-auto">
                          <select v-model="dateFilterRange.fromYear" @change="updateDateRange" class="form-select form-select-sm" style="width: 80px;">
                            <option value="">{{ showEthiopianDates ? 'ዓ/ም' : 'Year' }}</option>
                            <option v-for="y in displayYearOptions" :key="y" :value="y">{{ y }}</option>
                          </select>
                        </div>

                        <div class="col-auto">
                          <span class="text-muted">—</span>
                        </div>

                        <div class="col-auto">
                          <span class="badge bg-secondary">To</span>
                        </div>
                        <div class="col-auto">
                          <select v-model="dateFilterRange.toDay" @change="updateDateRange" class="form-select form-select-sm" style="width: 65px;">
                            <option value="">{{ showEthiopianDates ? 'ቀን' : 'Day' }}</option>
                            <option v-for="d in toDaysInMonth" :key="d" :value="d">{{ d }}</option>
                          </select>
                        </div>
                        <div class="col-auto">
                          <select v-model="dateFilterRange.toMonth" @change="onToMonthChange" class="form-select form-select-sm" style="width: 115px;">
                            <option value="">{{ showEthiopianDates ? 'ወር' : 'Month' }}</option>
                            <option v-for="m in displayMonths" :key="m.value" :value="m.value">
                              {{ showEthiopianDates ? m.label : m.labelShort }}
                            </option>
                          </select>
                        </div>
                        <div class="col-auto">
                          <select v-model="dateFilterRange.toYear" @change="updateDateRange" class="form-select form-select-sm" style="width: 80px;">
                            <option value="">{{ showEthiopianDates ? 'ዓ/ም' : 'Year' }}</option>
                            <option v-for="y in displayYearOptions" :key="y" :value="y">{{ y }}</option>
                          </select>
                        </div>

                        <div class="col-auto">
                          <button type="button" class="btn btn-primary btn-sm" @click="applyDateFilter" :disabled="!isValidDateRange" title="Apply Filter">
                            <i class="bx bx-filter-alt"></i>
                          </button>
                        </div>
                        <div class="col-auto" v-if="hasDateSelection">
                          <button type="button" class="btn btn-outline-danger btn-sm" @click="clearDateFilter" title="Clear Filter">
                            <i class="bx bx-x"></i>
                          </button>
                        </div>

                        <div class="col-auto ms-2">
                          <div class="btn-group btn-group-sm" role="group">
                            <button type="button" class="btn btn-outline-secondary" @click="setQuickDateRange('today')" title="Today">Today</button>
                            <button type="button" class="btn btn-outline-secondary" @click="setQuickDateRange('week')" title="This Week">Week</button>
                            <button type="button" class="btn btn-outline-secondary" @click="setQuickDateRange('month')" title="This Month">Month</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-2" v-if="alternateDateDisplay">
                    <div class="col-12">
                      <small :class="showEthiopianDates ? 'text-success' : 'text-primary'">
                        <i class="bx bx-calendar-check me-1"></i>
                        <strong>{{ showEthiopianDates ? 'Gregorian' : 'Ethiopian' }}:</strong>
                        {{ alternateDateDisplay }}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <h4 class="card-title text-uppercase mb-0">
                      All Available Designations
                    </h4>

                    <div class="d-flex">
                      <button @click="showCreateModal" type="button" class="btn btn-primary waves-effect btn-label waves-light text-uppercase">
                        <i class="bx bx-plus label-icon"></i> New Designation
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-header bg-white border-bottom py-3">
                  <div class="btn-toolbar d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input v-model="filters.searchTerm" @input="searchDesignations" type="text" class="form-control bg-light border-light rounded" placeholder="Search..." spellcheck="false">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex">
                      <div class="d-flex align-items-center">
                        <div class="d-flex justify-content-between">
                          <div class="float-end d-flex">
                            <div class="input-group fw-semibold text-uppercase me-3">
                              <label class="input-group-text text-uppercase">Status</label>
                              <select v-model="filters.status" @change="searchDesignations" class="form-select">
                                <option value="">All Statuses</option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <div v-if="loading" class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <p class="mt-2">Loading designations...</p>
                  </div>

                  <div v-else class="table-responsive">
                    <table class="table align-middle table-hover contacts-table text-uppercase border">
                      <thead class="table-light">
                      <tr>
                        <th scope="col">SN</th>
                        <th scope="col">Name</th>
                        <th scope="col">Employees Count</th>
                        <th scope="col">Status</th>
                        <th scope="col">Last Updated</th>
                        <th class="text-right">Actions</th>
                      </tr>
                      </thead>
                      <tbody class="border">
                      <tr v-for="(designation, index) in designations" :key="designation.designation_id">
                        <td>{{ (currentPage - 1) * pageSize + index + 1 }}.</td>
                        <td>{{ designation.designation_name }}</td>
                        <td>{{ designation.actual_employee_count || designation.employee_count || 0 }}</td>
                        <td class="fw-bold text-black">
                          <p class="mb-2 text-truncate">
                            <i :class="getStatusIcon(designation.status)"></i> {{ formatStatus(designation.status) }}
                          </p>
                        </td>
                        <td>{{ formatDateDisplay(designation.updated_at) }}</td>
                        <td class="text-uppercase text-right">
                          <div class="d-flex justify-content-end">
                            <button @click="editDesignation(designation)" class="btn btn-sm btn-success text-uppercase" title="Edit Designation">Edit</button>
                            <button @click="showDetailsModal(designation)" class="btn btn-sm btn-info text-uppercase mx-2" title="View Designation Details">Details</button>
                            <button v-if="designation.status === 'active'" @click="showDeactivateModal(designation)" class="btn btn-sm btn-danger text-uppercase d-flex align-items-center" title="Deactivate Designation">
                              <div>Deactivate</div>
                            </button>
                            <button v-else @click="activateDesignation(designation)" class="btn btn-sm btn-primary text-uppercase d-flex align-items-center" title="Activate Designation">
                              <div>Activate</div>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <div v-if="designations.length === 0" class="text-center py-4">
                      <p class="text-muted">No designations found</p>
                    </div>

                    <div v-if="totalCount > pageSize" class="row mt-3">
                      <div class="col-sm-12 col-md-5">
                        <div class="dataTables_info">
                          Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize, totalCount) }} of {{ totalCount }} entries
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-7">
                        <div class="dataTables_paginate paging_simple_numbers float-end">
                          <ul class="pagination">
                            <li class="paginate_button page-item previous" :class="{ disabled: currentPage === 1 }">
                              <a @click="changePage(currentPage - 1)" class="page-link">Previous</a>
                            </li>
                            <li v-for="page in totalPages" :key="page" class="paginate_button page-item" :class="{ active: currentPage === page }">
                              <a @click="changePage(page)" class="page-link">{{ page }}</a>
                            </li>
                            <li class="paginate_button page-item next" :class="{ disabled: currentPage === totalPages }">
                              <a @click="changePage(currentPage + 1)" class="page-link">Next</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Creating New Designation Modal -->
      <div v-if="showCreate" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content modal-md">
            <div class="modal-header border-bottom-0">
              <h4 class="modal-title text-uppercase">New Designation</h4>
              <button type="button" class="btn-close" @click="closeCreateModal"></button>
            </div>
            <div class="modal-body">
              <div v-if="alert.show" :class="`alert alert-${alert.type}`" role="alert">
                {{ alert.message }}
              </div>

              <div class="row">
                <div class="col-6 mb-3">
                  <div class="mb-3">
                    <label for="designation-name" class="form-label">Name <strong class="text-danger fw-bold">*</strong></label>
                    <input v-model="form.designationName" type="text" class="form-control" id="designation-name" placeholder="Enter Designation Name" required>
                  </div>
                </div>

                <div class="col-6 mb-3">
                  <div class="mb-3">
                    <label for="status" class="form-label">Status <strong class="text-danger fw-bold">*</strong></label>
                    <select v-model="form.status" id="status" class="form-select" required>
                      <option value="" disabled>Select Status</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                </div>

                <div class="col-12 mb-3">
                  <div class="mb-3">
                    <label for="description" class="form-label">Role Description</label>
                    <textarea v-model="form.description" id="description" placeholder="Enter Description" class="form-control" rows="3"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex flex-wrap gap-2 text-uppercase">
                <button @click="createDesignation" :disabled="createLoading" type="submit" class="btn btn-primary waves-effect waves-light">
                  <span v-if="createLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ createLoading ? 'Saving...' : 'Save' }}
                </button>
                <button @click="closeCreateModal" type="button" class="btn btn-secondary waves-effect">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Edit Designation Modal -->
      <div v-if="showEdit" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content modal-md">
            <div class="modal-header border-bottom-0">
              <h4 class="modal-title text-uppercase">Edit Designation</h4>
              <button type="button" class="btn-close" @click="closeEditModal"></button>
            </div>
            <div class="modal-body">
              <div v-if="alert.show" :class="`alert alert-${alert.type}`" role="alert">
                {{ alert.message }}
              </div>

              <div class="row">
                <div class="col-6 mb-3">
                  <div class="mb-3">
                    <label for="edit-designation-name" class="form-label">Name <strong class="text-danger fw-bold">*</strong></label>
                    <input v-model="editForm.designationName" type="text" class="form-control" id="edit-designation-name">
                  </div>
                </div>

                <div class="col-6 mb-3">
                  <div class="mb-3">
                    <label for="edit-status" class="form-label">Status <strong class="text-danger fw-bold">*</strong></label>
                    <select v-model="editForm.status" id="edit-status" class="form-select">
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                </div>

                <div class="col-12 mb-3">
                  <div class="mb-3">
                    <label for="edit-description" class="form-label">Role Description</label>
                    <textarea v-model="editForm.description" id="edit-description" class="form-control" rows="3"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex flex-wrap gap-2 text-uppercase">
                <button @click="updateDesignation" :disabled="editLoading" type="submit" class="btn btn-primary waves-effect waves-light">
                  <span v-if="editLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ editLoading ? 'Saving...' : 'Save Changes' }}
                </button>
                <button @click="closeEditModal" type="button" class="btn btn-secondary waves-effect">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Designation Details Modal -->
      <div v-if="showDetails" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title text-uppercase">Designation Details</h4>
              <button type="button" class="btn-close" @click="closeDetailsModal"></button>
            </div>
            <div class="modal-body">
              <div v-if="detailsLoading" class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>

              <div v-else-if="selectedDesignation" class="row">
                <div class="col-md-6 mb-3">
                  <label class="text-muted">Designation Name</label>
                  <p class="fw-bold">{{ selectedDesignation.designation_name }}</p>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="text-muted">Status</label>
                  <p class="fw-bold">
                    <span :class="selectedDesignation.status === 'active' ? 'text-success' : 'text-danger'">
                      {{ formatStatus(selectedDesignation.status) }}
                    </span>
                  </p>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="text-muted">Employee Count</label>
                  <p class="fw-bold">{{ selectedDesignation.actual_employee_count || selectedDesignation.employee_count || 0 }}</p>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="text-muted">Created By</label>
                  <p class="fw-bold">{{ selectedDesignation.created_by_name }} {{ selectedDesignation.created_by_lastname }}</p>
                </div>

                <div class="col-12 mb-3">
                  <label class="text-muted">Description</label>
                  <p class="fw-bold">{{ selectedDesignation.description || 'No description available' }}</p>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="text-muted">Created At</label>
                  <p class="fw-bold">{{ formatDateDisplay(selectedDesignation.created_at) }}</p>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="text-muted">Last Updated</label>
                  <p class="fw-bold">{{ formatDateDisplay(selectedDesignation.updated_at) }}</p>
                </div>

                <div v-if="employees && employees.length > 0" class="col-12 mt-3">
                  <h5 class="text-uppercase mb-3">Employees with this Designation</h5>
                  <table class="table table-sm table-bordered">
                    <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Department</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="employee in employees" :key="employee.user_id">
                      <td>{{ employee.first_name }} {{ employee.last_name }}</td>
                      <td>{{ employee.email }}</td>
                      <td>{{ employee.department_name || 'N/A' }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary text-uppercase" @click="closeDetailsModal">Close</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Deactivate Modal -->
      <div v-if="showDeactivate" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content modal-md">
            <div class="modal-header border-bottom-0">
              <h4 class="modal-title text-uppercase">Deactivate Designation</h4>
              <button type="button" class="btn-close" @click="closeDeactivateModal"></button>
            </div>
            <div class="modal-body">
              <div v-if="alert.show" :class="`alert alert-${alert.type}`" role="alert">
                {{ alert.message }}
              </div>

              <p>Are you sure you want to deactivate the designation <strong class="text-primary">{{ selectedDesignation?.designation_name }}</strong>?</p>
              <div class="row">
                <div class="col-12 mb-3">
                  <label for="deactivation-reason" class="form-label">Reason for Deactivation (Optional)</label>
                  <textarea v-model="deactivateReason" id="deactivation-reason" placeholder="Provide reason for deactivation" class="form-control" rows="3"></textarea>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="d-flex flex-wrap gap-2 text-uppercase">
                <button @click="deactivateDesignation" :disabled="deactivateLoading" type="submit" class="btn btn-danger waves-effect waves-light">
                  <span v-if="deactivateLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ deactivateLoading ? 'Processing...' : 'Confirm Deactivation' }}
                </button>
                <button @click="closeDeactivateModal" type="button" class="btn btn-secondary waves-effect">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              © Hospital Management Information System
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                2024
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>

  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import { authUrl, executeJson } from "@/api";

export default {
  name: "Designations",
  components: { NavigationBar },
  data() {
    return {
      loading: false, createLoading: false, editLoading: false, deactivateLoading: false, detailsLoading: false,
      showCreate: false, showEdit: false, showDeactivate: false, showDetails: false,
      designations: [], selectedDesignation: null, employees: [], deactivateReason: '',
      currentPage: 1, pageSize: 50, totalCount: 0,
      filters: { searchTerm: '', status: '', startDate: '', endDate: '' },
      form: { designationName: '', status: 'active', description: '' },
      editForm: { designationId: '', designationName: '', status: '', description: '' },
      alert: { show: false, type: 'success', message: '' },

      // Ethiopian Calendar State
      showEthiopianDates: true,
      currentEthiopianDate: { year: 2017, month: 3, day: 15, monthName: 'ህዳር', monthNameEn: 'Hidar' },
      dateFilterRange: { fromDay: '', fromMonth: '', fromYear: '', toDay: '', toMonth: '', toYear: '' },

      ethiopianMonths: [
        { value: 1, label: 'መስከረም', labelEn: 'Meskerem' }, { value: 2, label: 'ጥቅምት', labelEn: 'Tikimt' },
        { value: 3, label: 'ህዳር', labelEn: 'Hidar' }, { value: 4, label: 'ታህሳስ', labelEn: 'Tahsas' },
        { value: 5, label: 'ጥር', labelEn: 'Tir' }, { value: 6, label: 'የካቲት', labelEn: 'Yekatit' },
        { value: 7, label: 'መጋቢት', labelEn: 'Megabit' }, { value: 8, label: 'ሚያዝያ', labelEn: 'Miyazya' },
        { value: 9, label: 'ግንቦት', labelEn: 'Ginbot' }, { value: 10, label: 'ሰኔ', labelEn: 'Sene' },
        { value: 11, label: 'ሐምሌ', labelEn: 'Hamle' }, { value: 12, label: 'ነሐሴ', labelEn: 'Nehase' },
        { value: 13, label: 'ጳጉሜ', labelEn: 'Pagume' }
      ],
      gregorianMonths: [
        { value: 1, label: 'January', labelShort: 'Jan' }, { value: 2, label: 'February', labelShort: 'Feb' },
        { value: 3, label: 'March', labelShort: 'Mar' }, { value: 4, label: 'April', labelShort: 'Apr' },
        { value: 5, label: 'May', labelShort: 'May' }, { value: 6, label: 'June', labelShort: 'Jun' },
        { value: 7, label: 'July', labelShort: 'Jul' }, { value: 8, label: 'August', labelShort: 'Aug' },
        { value: 9, label: 'September', labelShort: 'Sep' }, { value: 10, label: 'October', labelShort: 'Oct' },
        { value: 11, label: 'November', labelShort: 'Nov' }, { value: 12, label: 'December', labelShort: 'Dec' }
      ]
    };
  },

  computed: {
    totalPages() { return Math.ceil(this.totalCount / this.pageSize); },
    ethiopianYearOptions() { const years = []; for (let y = this.currentEthiopianDate.year - 20; y <= this.currentEthiopianDate.year + 5; y++) years.push(y); return years; },
    gregorianYearOptions() { const cy = new Date().getFullYear(); const years = []; for (let y = cy - 20; y <= cy + 5; y++) years.push(y); return years; },
    displayMonths() { return this.showEthiopianDates ? this.ethiopianMonths : this.gregorianMonths; },
    displayYearOptions() { return this.showEthiopianDates ? this.ethiopianYearOptions : this.gregorianYearOptions; },
    fromDaysInMonth() { return this.showEthiopianDates ? this.getDaysInEthiopianMonth(this.dateFilterRange.fromMonth, this.dateFilterRange.fromYear) : this.getDaysInGregorianMonth(this.dateFilterRange.fromMonth, this.dateFilterRange.fromYear); },
    toDaysInMonth() { return this.showEthiopianDates ? this.getDaysInEthiopianMonth(this.dateFilterRange.toMonth, this.dateFilterRange.toYear) : this.getDaysInGregorianMonth(this.dateFilterRange.toMonth, this.dateFilterRange.toYear); },
    hasDateSelection() { return (this.dateFilterRange.fromDay && this.dateFilterRange.fromMonth && this.dateFilterRange.fromYear) || (this.dateFilterRange.toDay && this.dateFilterRange.toMonth && this.dateFilterRange.toYear); },
    isValidDateRange() { return this.dateFilterRange.fromDay && this.dateFilterRange.fromMonth && this.dateFilterRange.fromYear && this.dateFilterRange.toDay && this.dateFilterRange.toMonth && this.dateFilterRange.toYear; },
    alternateDateDisplay() {
      if (!this.isValidDateRange) return '';
      if (this.showEthiopianDates) {
        const fromGreg = this.ethiopianToGregorian(parseInt(this.dateFilterRange.fromYear), parseInt(this.dateFilterRange.fromMonth), parseInt(this.dateFilterRange.fromDay));
        const toGreg = this.ethiopianToGregorian(parseInt(this.dateFilterRange.toYear), parseInt(this.dateFilterRange.toMonth), parseInt(this.dateFilterRange.toDay));
        if (!fromGreg || !toGreg) return '';
        const fmt = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
        return `${fmt(fromGreg)} — ${fmt(toGreg)}`;
      } else {
        const fromEth = this.gregorianToEthiopian(new Date(parseInt(this.dateFilterRange.fromYear), parseInt(this.dateFilterRange.fromMonth) - 1, parseInt(this.dateFilterRange.fromDay)));
        const toEth = this.gregorianToEthiopian(new Date(parseInt(this.dateFilterRange.toYear), parseInt(this.dateFilterRange.toMonth) - 1, parseInt(this.dateFilterRange.toDay)));
        if (!fromEth || !toEth) return '';
        return `${fromEth.monthNameEn} ${fromEth.day}, ${fromEth.year} — ${toEth.monthNameEn} ${toEth.day}, ${toEth.year}`;
      }
    }
  },

  watch: { showEthiopianDates() { this.dateFilterRange = { fromDay: '', fromMonth: '', fromYear: '', toDay: '', toMonth: '', toYear: '' }; } },

  mounted() {
    this.currentEthiopianDate = this.getCurrentEthiopianDate();
    this.fetchDesignations();
  },

  methods: {
    // Ethiopian Calendar Methods
    getDaysInEthiopianMonth(month, year) { if (!month || !year) return 30; const m = parseInt(month), y = parseInt(year); if (m === 13) return (y % 4 === 3) ? 6 : 5; return 30; },
    getDaysInGregorianMonth(month, year) { if (!month || !year) return 31; const m = parseInt(month), y = parseInt(year); if ([1,3,5,7,8,10,12].includes(m)) return 31; if ([4,6,9,11].includes(m)) return 30; if (m === 2) return ((y % 4 === 0 && y % 100 !== 0) || (y % 400 === 0)) ? 29 : 28; return 31; },
    ethiopianToGregorian(ethYear, ethMonth, ethDay) { const EPOCH = 1724221; const jdn = EPOCH + 365 * (ethYear - 1) + Math.floor(ethYear / 4) + 30 * (ethMonth - 1) + ethDay - 1; const a = jdn + 32044; const b = Math.floor((4 * a + 3) / 146097); const c = a - Math.floor(146097 * b / 4); const d = Math.floor((4 * c + 3) / 1461); const e = c - Math.floor(1461 * d / 4); const m = Math.floor((5 * e + 2) / 153); return new Date(100 * b + d - 4800 + Math.floor(m / 10), m + 3 - 12 * Math.floor(m / 10) - 1, e - Math.floor((153 * m + 2) / 5) + 1); },
    gregorianToEthiopian(gregDate) { const date = typeof gregDate === 'string' ? new Date(gregDate) : gregDate; if (!date || isNaN(date.getTime())) return null; const gYear = date.getFullYear(), gMonth = date.getMonth() + 1, gDay = date.getDate(); const a = Math.floor((14 - gMonth) / 12); const y = gYear + 4800 - a; const m = gMonth + 12 * a - 3; const jdn = gDay + Math.floor((153 * m + 2) / 5) + 365 * y + Math.floor(y / 4) - Math.floor(y / 100) + Math.floor(y / 400) - 32045; const EPOCH = 1724221; const r = (jdn - EPOCH) % 1461; const n = r % 365 + 365 * Math.floor(r / 1460); const ethYear = 4 * Math.floor((jdn - EPOCH) / 1461) + Math.floor(r / 365) - Math.floor(r / 1460) + 1; const ethMonth = Math.floor(n / 30) + 1; const ethDay = n % 30 + 1; const monthData = this.ethiopianMonths.find(mon => mon.value === ethMonth); return { year: ethYear, month: ethMonth, day: ethDay, monthName: monthData?.label || '', monthNameEn: monthData?.labelEn || '' }; },
    getCurrentEthiopianDate() { return this.gregorianToEthiopian(new Date()); },
    formatDateDisplay(dateString) { if (!dateString) return 'N/A'; if (this.showEthiopianDates) { const eth = this.gregorianToEthiopian(dateString); if (eth) return `${eth.monthNameEn} ${eth.day}, ${eth.year}`; } const d = new Date(dateString); return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }); },
    onFromMonthChange() { if (this.dateFilterRange.fromDay > this.fromDaysInMonth) this.dateFilterRange.fromDay = this.fromDaysInMonth; this.updateDateRange(); },
    onToMonthChange() { if (this.dateFilterRange.toDay > this.toDaysInMonth) this.dateFilterRange.toDay = this.toDaysInMonth; this.updateDateRange(); },
    updateDateRange() {
      if (this.dateFilterRange.fromDay && this.dateFilterRange.fromMonth && this.dateFilterRange.fromYear) {
        let fromGreg = this.showEthiopianDates ? this.ethiopianToGregorian(parseInt(this.dateFilterRange.fromYear), parseInt(this.dateFilterRange.fromMonth), parseInt(this.dateFilterRange.fromDay)) : new Date(parseInt(this.dateFilterRange.fromYear), parseInt(this.dateFilterRange.fromMonth) - 1, parseInt(this.dateFilterRange.fromDay));
        if (fromGreg) this.filters.startDate = fromGreg.toISOString().split('T')[0];
      }
      if (this.dateFilterRange.toDay && this.dateFilterRange.toMonth && this.dateFilterRange.toYear) {
        let toGreg = this.showEthiopianDates ? this.ethiopianToGregorian(parseInt(this.dateFilterRange.toYear), parseInt(this.dateFilterRange.toMonth), parseInt(this.dateFilterRange.toDay)) : new Date(parseInt(this.dateFilterRange.toYear), parseInt(this.dateFilterRange.toMonth) - 1, parseInt(this.dateFilterRange.toDay));
        if (toGreg) this.filters.endDate = toGreg.toISOString().split('T')[0];
      }
    },
    applyDateFilter() { if (this.isValidDateRange) { this.updateDateRange(); this.currentPage = 1; this.fetchDesignations(); } },
    clearDateFilter() { this.dateFilterRange = { fromDay: '', fromMonth: '', fromYear: '', toDay: '', toMonth: '', toYear: '' }; this.filters.startDate = ''; this.filters.endDate = ''; this.currentPage = 1; this.fetchDesignations(); },
    setQuickDateRange(period) {
      const today = new Date(); let startDate = new Date(), endDate = new Date();
      switch(period) { case 'today': startDate = new Date(); break; case 'week': startDate.setDate(today.getDate() - 7); break; case 'month': startDate.setDate(1); break; }
      this.filters.startDate = startDate.toISOString().split('T')[0]; this.filters.endDate = endDate.toISOString().split('T')[0];
      if (this.showEthiopianDates) { const sE = this.gregorianToEthiopian(startDate), eE = this.gregorianToEthiopian(endDate); if (sE && eE) this.dateFilterRange = { fromDay: sE.day, fromMonth: sE.month, fromYear: sE.year, toDay: eE.day, toMonth: eE.month, toYear: eE.year }; }
      else this.dateFilterRange = { fromDay: startDate.getDate(), fromMonth: startDate.getMonth() + 1, fromYear: startDate.getFullYear(), toDay: endDate.getDate(), toMonth: endDate.getMonth() + 1, toYear: endDate.getFullYear() };
      this.currentPage = 1; this.fetchDesignations();
    },

    // Fetch designations
    async fetchDesignations() {
      this.loading = true; this.clearAlert();
      const data = { function: "getDesignations", status: this.filters.status, searchTerm: this.filters.searchTerm, startDate: this.filters.startDate, endDate: this.filters.endDate, limit: this.pageSize, offset: (this.currentPage - 1) * this.pageSize };
      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success) { this.designations = response.data.data.designations || []; this.totalCount = response.data.data.total || 0; }
        else { this.showAlertMsg('danger', response.data.message || 'Failed to fetch designations'); }
      } catch (error) { this.showAlertMsg('danger', error.message || 'An error occurred while fetching designations'); }
      finally { this.loading = false; }
    },

    searchDesignations() { this.currentPage = 1; this.fetchDesignations(); },
    changePage(page) { if (page >= 1 && page <= this.totalPages) { this.currentPage = page; this.fetchDesignations(); } },
    showCreateModal() { this.showCreate = true; this.clearAlert(); this.resetForm(); },
    closeCreateModal() { this.showCreate = false; this.clearAlert(); this.resetForm(); },
    resetForm() { this.form = { designationName: '', status: 'active', description: '' }; },

    async createDesignation() {
      if (!this.form.designationName) { this.showAlertMsg('danger', 'Designation name is required'); return; }
      this.createLoading = true; this.clearAlert();
      const data = { function: "createDesignation", designationName: this.form.designationName, status: this.form.status, description: this.form.description };
      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success) { this.showAlertMsg('success', response.data.message || 'Designation created successfully'); setTimeout(() => { this.closeCreateModal(); this.fetchDesignations(); }, 2000); }
        else { this.showAlertMsg('danger', response.data.message || 'Failed to create designation'); }
      } catch (error) { this.showAlertMsg('danger', error.message || 'An error occurred while creating designation'); }
      finally { this.createLoading = false; }
    },

    editDesignation(designation) { this.selectedDesignation = designation; this.editForm = { designationId: designation.designation_id, designationName: designation.designation_name, status: designation.status, description: designation.description || '' }; this.showEdit = true; this.clearAlert(); },
    closeEditModal() { this.showEdit = false; this.clearAlert(); this.selectedDesignation = null; },

    async updateDesignation() {
      if (!this.editForm.designationName) { this.showAlertMsg('danger', 'Designation name is required'); return; }
      this.editLoading = true; this.clearAlert();
      const data = { function: "updateDesignation", designationId: this.editForm.designationId, designationName: this.editForm.designationName, status: this.editForm.status, description: this.editForm.description };
      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success) { this.showAlertMsg('success', response.data.message || 'Designation updated successfully'); setTimeout(() => { this.closeEditModal(); this.fetchDesignations(); }, 2000); }
        else { this.showAlertMsg('danger', response.data.message || 'Failed to update designation'); }
      } catch (error) { this.showAlertMsg('danger', error.message || 'An error occurred while updating designation'); }
      finally { this.editLoading = false; }
    },

    async showDetailsModal(designation) {
      this.showDetails = true; this.detailsLoading = true; this.selectedDesignation = null; this.employees = [];
      const data = { function: "getDesignationDetails", designationId: designation.designation_id };
      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success) { this.selectedDesignation = response.data.data.designation; this.employees = response.data.data.employees || []; }
        else { this.showAlertMsg('danger', response.data.message || 'Failed to fetch designation details'); }
      } catch (error) { this.showAlertMsg('danger', error.message || 'An error occurred while fetching designation details'); }
      finally { this.detailsLoading = false; }
    },

    closeDetailsModal() { this.showDetails = false; this.selectedDesignation = null; this.employees = []; },
    showDeactivateModal(designation) { this.selectedDesignation = designation; this.showDeactivate = true; this.clearAlert(); this.deactivateReason = ''; },
    closeDeactivateModal() { this.showDeactivate = false; this.clearAlert(); this.selectedDesignation = null; this.deactivateReason = ''; },

    async deactivateDesignation() {
      this.deactivateLoading = true; this.clearAlert();
      const data = { function: "deactivateDesignation", designationId: this.selectedDesignation.designation_id, reason: this.deactivateReason };
      try {
        const response = await executeJson(data, authUrl);
        if (response.data.success) { this.showAlertMsg('success', response.data.message || 'Designation deactivated successfully'); setTimeout(() => { this.closeDeactivateModal(); this.fetchDesignations(); }, 2000); }
        else { this.showAlertMsg('danger', response.data.message || 'Failed to deactivate designation'); }
      } catch (error) { this.showAlertMsg('danger', error.message || 'An error occurred while deactivating designation'); }
      finally { this.deactivateLoading = false; }
    },

    async activateDesignation(designation) {
      if (confirm(`Are you sure you want to activate ${designation.designation_name}?`)) {
        const data = { function: "updateDesignation", designationId: designation.designation_id, status: 'active' };
        try {
          const response = await executeJson(data, authUrl);
          if (response.data.success) { this.showAlertMsg('success', 'Designation activated successfully'); this.fetchDesignations(); }
          else { this.showAlertMsg('danger', response.data.message || 'Failed to activate designation'); }
        } catch (error) { this.showAlertMsg('danger', error.message || 'An error occurred while activating designation'); }
      }
    },

    formatStatus(status) { return status.charAt(0).toUpperCase() + status.slice(1); },
    getStatusIcon(status) { const icons = { 'active': 'mdi mdi-circle text-success me-1', 'inactive': 'mdi mdi-circle text-danger me-1' }; return icons[status] || 'mdi mdi-circle text-secondary me-1'; },
    showAlertMsg(type, message) { this.alert = { show: true, type: type, message: message }; if (type === 'success') { setTimeout(() => { this.clearAlert(); }, 5000); } },
    clearAlert() { this.alert = { show: false, type: 'success', message: '' }; }
  }
};
</script>

<style scoped>
.spinner-border-sm { width: 1rem; height: 1rem; }
.modal.show { display: block !important; }
.btn:disabled { opacity: 0.6; cursor: not-allowed; }
.search-icon { position: absolute; top: 50%; right: 10px; transform: translateY(-50%); color: #74788d; }
.pagination { margin-bottom: 0; }
.page-link { cursor: pointer; }
.page-item.disabled .page-link { cursor: not-allowed; }
.page-item.active .page-link { background-color: #5664d2; border-color: #5664d2; }
.btn-check:checked + .btn-outline-primary { background-color: #0d6efd; color: white; }
.btn-check:checked + .btn-outline-success { background-color: #198754; color: white; }
</style>